"use strict";

require("core-js/modules/es.object.define-property");

require("core-js/modules/es.object.keys");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = dispatchTrackingEvent;

function dispatchTrackingEvent(data) {
  if (Object.keys(data).length > 0) {
    (window.dataLayer = window.dataLayer || []).push(data);
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/react-tracking/build/dispatchTrackingEvent.js
// module id = 1330
// module chunks = 3